import { Box, Tabs as MuiTabs } from '@mui/material';
import { ReactNode, useEffect } from 'react';
import { AnalyticsEvents } from '../../../enums/AnalyticsEvents';
import useActiveTab from '../../../hooks/useActiveTab';
import { useAnalytics } from '../../../hooks/useAnalytics';
import StyledTab from './StyledTab';
import TabContent from './TabContent';

interface TabsProps {
  labels: string[];
  contents: ReactNode[];
}

const Tabs = ({ labels, contents }: TabsProps) => {
  const { activeTab, setActiveTab } = useActiveTab();
  const { track } = useAnalytics();

  const handleChange = (event: React.SyntheticEvent, newValue: number) => {
    setActiveTab(newValue);
  };

  useEffect(() => {
    if (activeTab === 0) {
      track(AnalyticsEvents.DASHBOARD_TABS_CALL_AGENTS_CLICKED);
    } else {
      track(AnalyticsEvents.DASHBOARD_TABS_CHAT_AGENTS_CLICKED);
    }
  }, [activeTab, track]);

  return (
    <Box sx={{ width: '100%' }}>
      <MuiTabs
        value={activeTab}
        onChange={handleChange}
        variant="fullWidth"
        sx={{
          p: 0.5,
          borderRadius: 999,
          bgcolor: '#FFFFFF',
          border: '1px solid rgba(15, 23, 42, 0.06)',
          boxShadow: '0px 8px 24px rgba(15, 23, 42, 0.08)',
          minHeight: 56,
          '& .MuiTabs-indicator': { display: 'none' },
        }}
      >
        {labels && labels.map(label => <StyledTab label={label} key={label} />)}
      </MuiTabs>
      {contents &&
        contents.map((content, index) => (
          <TabContent key={index} value={activeTab} index={index}>
            {content}
          </TabContent>
        ))}
    </Box>
  );
};

export default Tabs;
